import React from 'react';

import { Card, Group, Skeleton, Stack } from '@mantine/core';

const WorkoutLoggerSkeleton = (): JSX.Element => (
  <Stack spacing='xs'>
    <Skeleton height={14} width={120} />
    <Card withBorder radius='md' p='md'>
      <Stack spacing='xl'>
        {[1, 2, 3].map(i => (
          <Stack key={i} spacing='xs'>
            <Group spacing='xs'>
              <Skeleton height={18} width='40%' />
              <Skeleton height={18} width={60} radius='sm' />
            </Group>
            <Skeleton height={36} />
          </Stack>
        ))}
      </Stack>
    </Card>
  </Stack>
);

export default WorkoutLoggerSkeleton;
